module.exports = __webpack_public_path__ + "img/few clouds.93b9070e.jpg";